import { render } from "./Order-page.vue?vue&type=template&id=05dce62a&scoped=true"
import script from "./Order-page.vue?vue&type=script&lang=js"
export * from "./Order-page.vue?vue&type=script&lang=js"

import "./Order-page.vue?vue&type=style&index=0&id=05dce62a&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dce62a"]])

export default __exports__